import PassportKioskHeaderControl from './PassportKioskHeaderControl';
import { ScanLimitHeaderChip } from './ScanLimitPurchase';
import { usePassportCheckinEnabled } from '../hooks/usePassportCheckinEnabled';
import { permissionService } from '../services/permissionService';
import './ScanLimitHeaderChip.css';

export default function PassportHeaderToolbar() {
  const enabled = usePassportCheckinEnabled();
  const showScanLimit = permissionService.isFranchise();
  if (!enabled && !showScanLimit) return null;
  return (
    <div className="passport-header-toolbar-row">
      {showScanLimit ? <ScanLimitHeaderChip /> : null}
      {enabled ? <PassportKioskHeaderControl /> : null}
    </div>
  );
}
